export function companyNavigationTarget(target: string, companyId: string | null) {
  if (!companyId) return target
  const url = new URL(target, "https://panel.invalid")
  if (!/^\/(?:my\/)?company(?:\/|$)/.test(url.pathname) || url.searchParams.has("company")) return target
  url.searchParams.set("company", companyId)
  return url.pathname + url.search + url.hash
}
